<template>

  <el-card class="card-main">
    <!-- <div class="main"> -->
      <!-- 查询 -->
      <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
        <el-form-item prop="projectName">
          <el-input v-model="searchInfo.supplierName" size="small" placeholder="请输入供应商名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="seedlingCode">
          <el-select v-model="searchInfo.supplierType" placeholder="请选择供应商类型" clearable filterable>
            <el-option
              v-for="item in typeList"
              :key="item.dicCode"
              :label="item.dicValue"
              :value="item.dicCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-plus" class="mb20" @click="add"  v-show="$ButtonShow('YHS_ADD_01')">新增</el-button>
      <el-table class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
        <el-table-column label="供应商编号" show-overflow-tooltip prop="supplierCode"></el-table-column>
        <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName"></el-table-column>
        <el-table-column label="供应商类型" show-overflow-tooltip prop="supplierTypeName"></el-table-column>
        <el-table-column label="经营范围" show-overflow-tooltip prop="operationScope"></el-table-column>
        <el-table-column label="地址" show-overflow-tooltip prop="address">
          <template v-slot="{ row }">
            {{row.province}}{{row.city}}{{row.area}}{{row.address}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="goDetail(row.supplierId)">查看</el-button>
            <el-button type="text" @click="edit(row.supplierId)" v-show="$ButtonShow('YHS_EDT_01')">编辑</el-button>
            <el-button type="text" @click="onDelete(row.supplierId)" v-show="$ButtonShow('YHS_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination
        @size-change="getData"
        @current-change="getData"
        :current-page.sync="page"
        :page-size.sync="size"
        :total="total"
      ></global-pagination>
    <!-- </div> -->
  </el-card>
</template>

<script>
export default {
  name: 'SuppliermanageList',
  data () {
    return {
      searchInfo: {
        supplierName: '',
        supplierType: ''
      },
      typeList: [],
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: []
    }
  },
  created () {
    this.getData()
    this.getConfigList()
  },
  methods: {
    // 查询
    searchData () {
      this.page = 1
      this.getData()
    },
    // 获取供应商类型
    getConfigList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'supplierType' }).then(res => {
        this.typeList = res.supplierType || []
      })
    },
    // 获取表格数据
    getData () {
      this.loading = true
      this.$axios.get(this.$apis.system.selectYhSupplierByPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    // 新增
    add () {
      this.$router.push('/suppliermanage/add')
    },
    edit (supplierId) {
      this.$router.push({
        path: '/suppliermanage/editd',
        query: {
          supplierId
        }
      })
    },
    goDetail (supplierId) {
      this.$router.push({
        path: '/suppliermanage/detail',
        query: {
          supplierId
        }
      })
    },
    onDelete (supplierId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.deleteYhSupplier, {
          supplierId: supplierId
        }).then(() => {
          this.$message.success('删除成功')
          this.searchData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
